import type { CreateClientConfig } from "./client/client.gen";
import { getApiBase, getCommonHeaders } from "./utils/net/apiRequestHeaders";

export const createClientConfig: CreateClientConfig = (config) => ({
  ...config,
  baseUrl: getApiBase(),
  throwOnError: true,
  fetch: (input, init) => {
    const headers = new Headers(init?.headers);
    for (const [key, value] of Object.entries(getCommonHeaders())) {
      headers.set(key, value);
    }
    return fetch(input, { ...init, headers });
  },
});
